module.exports = __webpack_public_path__ + "static/frontUserNew/img/typevideo.f19054f4.svg";